export default {"src":"/_next/static/media/twitter.6f90792a.svg","height":50,"width":50};